import { Injectable, signal } from '@angular/core';
import { ViewQuery } from '@xanadu/model';
import { Consent, Reply } from '@xanadu/support';

@Injectable({
    providedIn: 'root'
})
export class CommonSignal {
    view = signal<ViewQuery | undefined>(undefined);
    consent = signal<Consent | undefined>(undefined);
    reply = signal<Reply | undefined>(undefined);
    httpError = signal<any | undefined>(undefined);
    tab = signal<any | undefined>(undefined);
}
